import {
	createRouter,
	//createWebHistory,
	createWebHashHistory
} from 'vue-router'
import login from '@/pages/login' //登录
import home from '@/pages/index/index' //首页
import contactus from '@/pages/contactus/index' //联系我们
import news from '@/pages/news/index' //健康资讯
import newsInfo from '@/pages/news/newsInfo' //健康资讯详细
import center from '@/pages/center/index' //个人中心

import patient from '@/pages/patient/index' //体检人
import help from '@/pages/patient/help' //帮助

import yuyue from '@/pages/yuyue/index' //预约选择
import myYuYue from '@/pages/yuyue/myYuYue' //我的预约列表
import yuyueDepart from '@/pages/yuyue/yuyueDepart' //科室预约

import suite from '@/pages/suite/index' //套餐项目
import suiteDetail from '@/pages/suite/detail' //套餐项目
import mycart from '@/pages/mycart/index' //我的购物车
import confirm from '@/pages/mycart/confirm' //我的购物车确认

import orderUnPay from '@/pages/order/orderUnPay' //订单-待付款
import orderUnPatient from '@/pages/order/orderUnPatient' //订单-待体检
import orderComplete from '@/pages/order/orderComplete' //订单-已完成
import orderCancel from '@/pages/order/orderCancel' //订单-已取消
// import nopage from '@/pages/404/nopage' //首页


import registerIndex from '@/pages/register/index' //登记预约
import registerConfirm from '@/pages/register/confirm' //登记预约-确认

import patient2 from '@/pages/patient2/index' //登记预约-确认

const routes = [{
		path: '/',
		name: 'login',
		component: login
	},
	{
		path: '/home',
		name: 'home',
		component: home
	},
	{
		path: '/contactus',
		name: 'contactus',
		component: contactus
	},
	{
		path: '/news',
		name: 'news',
		component: news
	},
	{
		path: '/newsInfo',
		name: 'newsInfo',
		component: newsInfo
	},
	{
		path: '/center',
		name: 'center',
		component: center
	},
	{
		path: '/patient',
		name: 'patient',
		component: patient
	},
	{
		path: '/patient2',
		name: 'patient2',
		component: patient2
	},	
	{
		path: '/help',
		name: 'help',
		component: help
	},
	{
		path: '/yuyue',
		name: 'yuyue',
		component: yuyue
	},
	{
		path: '/myYuYue',
		name: 'myYuYue',
		component: myYuYue
	},
	{
		path: '/yuyueDepart',
		name: 'yuyueDepart',
		component: yuyueDepart
	},

	{
		path: '/suite',
		name: 'suite',
		component: suite
	},
	{
		path: '/suiteDetail',
		name: 'suiteDetail',
		component: suiteDetail
	},
	{
		path: '/mycart',
		name: 'mycart',
		component: mycart
	},
	{
		path: '/confirm',
		name: 'confirm',
		component: confirm
	},

	{
		path: '/orderUnPay',
		name: 'orderUnPay',
		component: orderUnPay
	},
	{
		path: '/orderUnPatient',
		name: 'orderUnPatient',
		component: orderUnPatient
	},
	{
		path: '/orderComplete',
		name: 'orderComplete',
		component: orderComplete
	},
	{
		path: '/orderCancel',
		name: 'orderCancel',
		component: orderCancel
	},
    {
		path: '/registerIndex',
		name: 'registerIndex',
		component: registerIndex
	},
	{
		path: '/registerConfirm',
		name: 'registerConfirm',
		component: registerConfirm
	},
	// {
	// 	path: '/nopage',
	// 	name: 'nopage',
	// 	component: nopage
	// },
]

const router = createRouter({
	routes,
	history: createWebHashHistory(process.env.BASE_URL),//createWebHistory
	scrollBehavior() {
		return {
			top: 0
		}
	}
})

export default router
